import { NETWORK, WEBSOCKETCONNECTION, WEBSOCKETSTATUS } from "./backbroundTypes";


const initialState = {
    calltype: "",
    session: {},
    webrtcManual: false,
    socket_message: {},
    oncall: false,
    networkstatus: "online",
    oncall_phonenumber: "",
    conference: [],
    websocket: {
        WrtcStatus: false,
        WsSocketStatus: false
    },
    ringing: false,
    activeconference: false,
    websocketconnection: {},
    audio: new Audio(`${"https://media.doocti.com/sounds/dv2-ringtone.wav"}`),
    isplay: false,
    triggerdispo: false,
    triggerreqpopup: false,
    oncalllead: [
        {
            lead_id: "",
            lead_name: "",
            phone_number: "",
            module: "",
            render: 0
        }
    ],
    tempdata: {
        type: "",
        data: {}
    }
};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case NETWORK:
            console.log("NETWORK===========>", action);
            return {
                ...state,
                networkstatus: action.payload
            };
        case WEBSOCKETCONNECTION:
            return {
                ...state,
                websocketconnection: action.payload
            };
        case WEBSOCKETSTATUS:
            let websocketstatus = state.websocket;
            if (action.payload.hasOwnProperty("WsSocketStatus")) {
                websocketstatus.WsSocketStatus = action.payload.WsSocketStatus;
            } else if (action.payload.hasOwnProperty("WrtcStatus")) {
                websocketstatus.WrtcStatus = action.payload.WrtcStatus;
            }

            return {
                ...state,
                websocket: websocketstatus,
            };
        default:
            return state;
    }
};

export default reducer;